import { useUserContext } from "../contexts/UserContext";
import { Permissions } from "../models/autogenerated-deliveryService-gql/graphql";

const usePermissionCheck = () => {
  const { user } = useUserContext();

  const hasPermission = (permission: Permissions): boolean =>
    user.permissions.includes(permission);

  const canViewStock = (): boolean => hasPermission(Permissions.CanViewStock);

  const canViewOutboundDeliveries = (): boolean =>
    hasPermission(Permissions.CanViewOutboundDelivery);

  return {
    hasPermission,
    canViewStock,
    canViewOutboundDeliveries,
  };
};

export default usePermissionCheck;
